/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxmUserauthV1RealmAccessState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXM_USERAUTH_V1_REALM_ACCESS_STATE_ENTITY_NAME = 'ixm.userauth.v1.RealmAccess';
export const ixmUserauthV1RealmAccessStateEntity = new schema.Entity<IxmUserauthV1RealmAccessState>(IXM_USERAUTH_V1_REALM_ACCESS_STATE_ENTITY_NAME, {}, { idAttribute: 'realmAccessId' });

